import type { UIPartyCharacter } from '@sorrem-client/types';

/** How many of the slots hold an item. */
export function countOccupiedSlots(items: Array<UIPartyCharacter['storedItems'][number]>): number {
    return items.reduce<number>((total, item) => (item ? total + 1 : total), 0);
}
